import { UseMutationOptions } from '@tanstack/react-query';

import { CommunicationType } from 'domains/content/types';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

export type CreateWhatsAppInput = {
    applicationsAccess?: string;
    name: string;
    language: string;
    components: any;
    componentsMultilingual?: Record<string, any[]>;
    communicationType?: CommunicationType;
    parentFolderId?: number;
    status?: string;
    whatsappAccountId?: string;
    whatsappNamespace?: string;
    whatsappTemplateId?: string;
};

const useCreateWhatsApp = (mutateOptions: UseMutationOptions<unknown, Error, CreateWhatsAppInput>) =>
    useMutation<CreateWhatsAppInput>(
        MutationKeys.CREATE_WHATSAPP_TEMPLATE,
        CuredApiPaths.WHATSAPP_TEMPLATES,
        mutateOptions
    );

export default useCreateWhatsApp;
